import React, { useState, useEffect, useRef, useContext } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import { useStylesOnglet } from '../onglets/Onglets.css';
import { useStylesGlobal } from "../../pages/GlobalStyle.css";
import rest from "../../rest";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import AppContext from '../appContext';
import heic2any from "heic2any";

const PhotoProfil = ({ open, setOpen, idBenevole, setPhotoError, isColseDisabled = false, currentUser }) => {
    const [selectImg, setSelectImg] = useState();
    const classesGlobal = useStylesGlobal();
    const classes = useStylesOnglet();
    const [croppedImage, setCroppedImage] = useState(null);
    const cropperRef = useRef(null);
    const [refresh, setRefresh] = useState(false);
    const myContext = useContext(AppContext);
    const [textPhoto, setTextPhoto] = useState('votre photo');
    

  const theme = useTheme();
  const querysmDown = useMediaQuery(theme.breakpoints.down("sm"));

    const onCrop = () => {
        const imageElement = cropperRef?.current;
        const cropper = imageElement?.cropper;
        setCroppedImage(cropper.getCroppedCanvas().toDataURL("image/jpeg"));
    };

    useEffect(() => {
        rest.post(`/parametres/configTextPhoto.json`, {}).then((response) => {
            setTextPhoto(response.data.message);
        });
    }, []);

    useEffect(() => {
        rest.post(`/benevols/getPicture.json`, { vIdPers: idBenevole }).then((response) => {
            if (response.data.picture !== "") {
                setSelectImg("data:image/jpeg;base64," + response.data.picture);
                myContext.setReload((prev) => !prev);
            }
        });
    }, [idBenevole, refresh, myContext]);

    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const isHEIC = (file) => {
        const extension = file.name.split('.').pop().toLowerCase();
        return extension === 'heic' || extension === 'heif';
    };

    const handleChange = async (event) => {
        const file = event.target.files[0];

        if (file) {
            // Vérifier si le fichier est HEIC par type MIME ou par extension
            if (file.type === "image/heic" || file.type === "image/heif" || isHEIC(file)) {
                // Convertir HEIC en JPEG
                try {
                    const blob = await heic2any({
                        blob: file,
                        toType: "image/jpeg",
                        quality: 0.9 // Vous pouvez ajuster la qualité selon vos besoins
                    });

                    // Créer un nouveau fichier JPEG à partir du Blob converti
                    const convertedFile = new File([blob], file.name.replace(/\.[^/.]+$/, ".jpg"), {
                        type: "image/jpeg",
                    });

                    const base64Image = await convertBase64(convertedFile);
                    setSelectImg(base64Image);
                } catch (error) {
                    console.error("Erreur lors de la conversion HEIC:", error);
                    setPhotoError(true);  // Gérer l'erreur comme vous le souhaitez
                }
            } else {
                // Gérer les autres formats d'image (JPEG, PNG, etc.)
                try {
                    const base64Image = await convertBase64(file);
                    setSelectImg(base64Image);
                } catch (error) {
                    console.error("Erreur lors de la conversion de l'image:", error);
                    setPhotoError(true);
                }
            }
        }
    };

    const handleClose = () => {
        setOpen(isColseDisabled);
    }

    const handleSave = () => {
        if (croppedImage) {
            rest.post(`/benevols/savePicture.json`, {
                vIdPers: idBenevole,
                picture: encodeURIComponent(croppedImage.split("base64,")[1])
            })
                .then((response) => {
                    if (setPhotoError) setPhotoError(response.data.error);
                    if (response.data.error === true) {
                        setOpen(true);
                    } else {
                        if (currentUser && currentUser.Person?.Person_Photo) currentUser.Person.Person_Photo = 'PhotoUpdated';
                        setOpen(false);
                        setRefresh(!refresh);
                        myContext.setReload((prev) => !prev);
                    }
                });
        } else {
            handleClose();
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Choisir une nouvelle photo de profil</DialogTitle>
            <DialogContent className={classes.root}>
                <DialogContentText>
                    <div dangerouslySetInnerHTML={{ __html: textPhoto }} />
                </DialogContentText>
            </DialogContent>
            <DialogContent className={classes.root}>
                <input
                    inputProps={{ accept: 'image/*' }}
                    className={classes.input}
                    id="contained-button-file"
                    multiple
                    type="file"
                    onChange={handleChange}
                />
                <DialogContentText >
                    {selectImg && (
                        <Cropper
                            src={selectImg}
                            crop={onCrop}
                            ref={cropperRef}
                            autoCrop={false}
                            background={false}
                            aspectRatio={1 / 1}
                            guides={false}
                            style={{ height: 400, width: "100%" }}
                        />
                    )}
                </DialogContentText>
                <DialogActions>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={5}>
                            <label htmlFor="contained-button-file">
                                <Button variant="contained" color="secondary" component="span" style={{width : querysmDown ? '100%': 'auto'}}>
                                    <PhotoCamera /> Choisir une photo
                                </Button>
                            </label>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Button variant="contained" color="primary" onClick={handleSave}  style={{width : querysmDown ? '100%': '100%'}}>
                                Enregistrer
                            </Button></Grid>
                        {!isColseDisabled && (
                            <Grid item xs={12} md={3}>
                                <Button variant="contained" className={classesGlobal.buttonFermer} onClick={handleClose} style={{width : querysmDown ? '100%': '100%'}}>
                                    Fermer
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default PhotoProfil;
